module.exports = __webpack_public_path__ + "img/kf.7b174e93.png";